var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.$options.components['advertisement-loading'] ? [_vm.isLoading ? _c('advertisement-loading') : _vm._e()] : _vm._e(), _vm.productList.length == 0 && !_vm.isLoading ? _c('div', {
    staticClass: "text-center no-item"
  }, [_vm._v(" " + _vm._s(_vm.$t("productStore.noItmes")) + " ")]) : _vm._e(), _c('div', [_c('b-card', {
    staticClass: "text-grey mx-5 my-4"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-form-input', {
    staticClass: "mt-2 col-10 border-radius-left-40",
    attrs: {
      "placeholder": "Search Store..."
    },
    model: {
      value: _vm.storeName,
      callback: function ($$v) {
        _vm.storeName = $$v;
      },
      expression: "storeName"
    }
  }), _c('button', {
    staticClass: "col search-button mt-2 ml-n1 border-radius-r-40",
    on: {
      "click": _vm.storeResult
    }
  }, [_c('b-icon', {
    staticClass: "margin-top-4",
    attrs: {
      "icon": "search"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm.productList && _vm.productList.length ? _c('sections-slider', {
    attrs: {
      "list": _vm.productList,
      "subTitle": _vm.$route.params.market,
      "showTitle": true,
      "hasBackground": false,
      "hasButton": false,
      "withoutSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var listItem = _ref.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          staticClass: "suggester-div w-100",
          attrs: {
            "isDoctor": true,
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true,
            "rating": listItem.avgRating || 0
          }
        })], 1)];
      }
    }], null, false, 3645492528)
  }) : _vm._e()], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }